var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeletedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0542 6.48769H4.87192C4.39037 6.48769 4 6.87807 4 7.35962C4 7.84117 4.39037 8.23154 4.87192 8.23154H24.0542C24.5358 8.23154 24.9262 7.84117 24.9262 7.35962C24.9262 6.87807 24.5358 6.48769 24.0542 6.48769Z",
    fill: "#232360"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9754 12.5912V19.5665C10.9754 20.0481 11.3658 20.4385 11.8473 20.4385C12.3289 20.4385 12.7192 20.0481 12.7192 19.5665V12.5912C12.7192 12.1096 12.3289 11.7192 11.8473 11.7192C11.3658 11.7192 10.9754 12.1096 10.9754 12.5912Z",
    fill: "#232360"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2069 12.5912V19.5665C16.2069 20.0481 16.5973 20.4385 17.0788 20.4385C17.5604 20.4385 17.9508 20.0481 17.9508 19.5665V12.5912C17.9508 12.1096 17.5604 11.7192 17.0788 11.7192C16.5973 11.7192 16.2069 12.1096 16.2069 12.5912Z",
    fill: "#232360"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48769 23.9262V7.35962C7.48769 6.87807 7.09732 6.48769 6.61577 6.48769C6.13422 6.48769 5.74385 6.87807 5.74385 7.35962V23.9262C5.74385 24.6485 6.25461 25.1592 6.25461 25.1592C6.76537 25.67 7.48769 25.67 7.48769 25.67H21.4385C22.1608 25.67 22.6716 25.1592 22.6716 25.1592C23.1823 24.6485 23.1823 23.9262 23.1823 23.9262V7.35962C23.1823 6.87807 22.7919 6.48769 22.3104 6.48769C21.8288 6.48769 21.4385 6.87807 21.4385 7.35962V23.9262H7.48769Z",
    fill: "#232360"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99768 3.76614C9.23154 4.53228 9.23154 5.61577 9.23154 5.61577V7.35962C9.23154 7.84117 9.62191 8.23154 10.1035 8.23154C10.585 8.23154 10.9754 7.84117 10.9754 7.35962V5.61577C10.9754 5.25461 11.2308 4.99923 11.2308 4.99923C11.4861 4.74385 11.8473 4.74385 11.8473 4.74385H17.0788C17.44 4.74385 17.6954 4.99923 17.6954 4.99923C17.9508 5.25461 17.9508 5.61577 17.9508 5.61577V7.35962C17.9508 7.84117 18.3411 8.23154 18.8227 8.23154C19.3042 8.23154 19.6946 7.84117 19.6946 7.35962V5.61577C19.6946 4.53228 18.9285 3.76614 18.9285 3.76614C18.1623 3 17.0788 3 17.0788 3H11.8473C10.7638 3 9.99768 3.76614 9.99768 3.76614Z",
    fill: "#232360"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletedIcon);
export default __webpack_public_path__ + "static/media/Deleted-icon.46309a04ff013c671a01408eaa3810b5.svg";
export { ForwardRef as ReactComponent };